import React from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { AssignTaskToStaffModal } from "../AssignTaskToStaffModal";

interface TasksCellProps {
  taskCount: number;
}

export const TasksCell: React.FC<TasksCellProps & { staffId: string }> = ({
  taskCount,
  staffId,
}) => {
  return (
    <div className="flex items-center gap-2 justify-center">
      <Badge
        variant="destructive"
        className={cn(
          "rounded-full px-2",
          taskCount <= 0 ? "bg-black" : "bg-destructive",
        )}
      >
        {taskCount}
      </Badge>
      <AssignTaskToStaffModal
        staffId={staffId}
        trigger={
          <Button
            variant="ghost"
            size="icon"
            className="h-6 w-6 rounded-full border-black hover:bg-muted"
          >
            <Plus className="h-4 w-4" />
          </Button>
        }
      />
    </div>
  );
};
